import { Reveal, SectionLabel } from "./shared";

const COUNTRIES = [
  { name: "United Kingdom", flag: "\u{1F1EC}\u{1F1E7}" },
  { name: "Australia", flag: "\u{1F1E6}\u{1F1FA}" },
  { name: "New Zealand", flag: "\u{1F1F3}\u{1F1FF}" },
  { name: "United States", flag: "\u{1F1FA}\u{1F1F8}" },
  { name: "Ireland", flag: "\u{1F1EE}\u{1F1EA}" },
  { name: "South Africa", flag: "\u{1F1FF}\u{1F1E6}" },
  { name: "Egypt", flag: "\u{1F1EA}\u{1F1EC}" },
  { name: "Germany", flag: "\u{1F1E9}\u{1F1EA}" },
];

const CastingVision = () => (
  <section
    id="vision"
    data-testid="vision-section"
    className="relative bg-[#121212] py-24 lg:py-32 border-t border-white/5"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionLabel number="05" title="Global Reach" />
      <Reveal>
        <h2 className="font-display text-white font-extrabold tracking-tighter uppercase text-4xl sm:text-5xl lg:text-6xl leading-none mb-4">
          The Casting Vision
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="text-[#cccccc] text-base sm:text-lg mb-14 max-w-xl">
          We have worked with performers from across the globe:
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#222]">
        {COUNTRIES.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.05}>
            <div
              data-testid={`country-${i + 1}`}
              className="group bg-[#121212] hover:bg-[#0a0a0a] transition-colors duration-300 p-8 flex items-center gap-4 h-full"
            >
              <span className="text-3xl grayscale group-hover:grayscale-0 transition-all duration-500">
                {c.flag}
              </span>
              <span className="font-display text-white text-lg font-semibold tracking-tight group-hover:text-[#d4af37] transition-colors duration-300">
                {c.name}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default CastingVision;
